import { Debug } from 'js/components/Util/Debug.js';
import { Scope } from 'js/components/AnalyticsDebugger/Scope';
import { EventNameTab } from 'js/components/AnalyticsDebugger/EventNameTab';
import { ScopeNameTab } from 'js/components/AnalyticsDebugger/ScopeNameTab';
import { SettingsTab } from 'js/components/AnalyticsDebugger/SettingsTab';
import { LogTab } from 'js/components/AnalyticsDebugger/LogTab';

class AnalyticsDebugger {
  constructor () {
    this.tabs = [];
    this.enable();
  }

  addSideMenu () {
    const sidemenu = document.createElement('div');
    sidemenu.classList.add('Analytics');

    const sidemenuToggles = document.createElement('div');
    sidemenuToggles.classList.add('Analytics-toggles');
    this.tabs.forEach(tab => sidemenuToggles.appendChild(tab.getButton()));

    const sidemenuTabs = document.createElement('div');
    sidemenuTabs.classList.add('Analytics-tabs');

    this.tabs.forEach(tab => sidemenuTabs.appendChild(tab.getTemplate()));

    sidemenu.appendChild(sidemenuToggles);
    sidemenu.appendChild(sidemenuTabs);

    document.body.appendChild(sidemenu);
  }

  addSideMenuToggling() {
    const AnalyticsList = document.querySelector('.Analytics');
    const buttons = document.querySelectorAll('.Analytics-toggles--item');
    const htmlTabs = document.querySelectorAll('.Analytics-tabs--item');

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      button.addEventListener('click', (evt) => {
        const target = evt.target;
        if (AnalyticsList.classList.contains('show')) {
          if (target.classList.contains('active')) {
            buttons.forEach(
              (button) => button.classList.remove('active')
            );
            AnalyticsList.classList.toggle('show');
            htmlTabs.forEach(
              (tab) => tab.classList.remove('active')
            );
          } else {
            buttons.forEach(
              (button) => button.classList.remove('active')
            );
            htmlTabs.forEach(
              (tab) => tab.classList.remove('active')
            );
            target.classList.toggle('active');
            htmlTabs[i].classList.add('active');
          }
        } else {
          AnalyticsList.classList.toggle('show');
          target.classList.toggle('active');
          htmlTabs[i].classList.add('active');
        }
      });
    }
  }

  enable() {
    this.tabs = [
      new EventNameTab(),
      new ScopeNameTab(),
      new SettingsTab()
    ];
    this.addSideMenu();
    this.addSideMenuToggling();
  }

  disable() {
    this.tabs = [];
    Debug.disable();
  }
}

export {
  AnalyticsDebugger
}
